<footer>
    <p>Copyright &copy; 2022 Aaron Dalton</p>
    <p>The source code for this site is <a href="https://github.com/Perlkonig/empirical-editors">available on GitHub</a>. The lists of articles are also available in JSON format: <a href="./data/research.json">research</a>, <a href="./data/casestudies.json">case studies</a>.</p>
</footer>

<style>
    footer {
	    font-size: smaller;
        padding-top: 1em;
        margin-top: 1em;
        border-top: 1px solid black;
    }
</style>